const EventEmitter = require('events');
const fields = require('./lib/fields');

class BaseModel extends EventEmitter {
    constructor(data) {
        if (!data) data = {};
        super();
        this.constructor.fieldList.forEach((field) => {
            field.init(this, data);
        });
    }
    serialize() {
        let data = {};
        this.constructor.fieldList.forEach((field) => {
            field.serialize(this, data);
        });
        return data;
    }
    deepUpdate(path, items) {
        if (path.length) {
            let [key, ...subpath] = path;
            this.constructor.fields[key].deepUpdate(this, subpath, items);
        } else {
            for (let [key, val] of Object.entries(items)) {
                this.constructor.fields[key].deepUpdate(this, [], val);
            }
        }
    }
}

function Model(fields) {
    let cls = class extends BaseModel {};
    cls.fieldList = fields;
    cls.fields = {};

    fields.forEach((field) => {
        cls.fields[field.name] = field;
        field.contributeToClass(cls);
    });

    return cls;
}

class Component {
    render() {}
    show() {}
    hide() {}
}

class ContainerComponent extends Component {
    show() {
        this.components.forEach((component) => {
            component.show();
        });
    }
    hide() {
        this.components.forEach((component) => {
            component.hide();
        });
    }
}

export { fields, Model, Component, ContainerComponent };
